import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

class EnsureLoggedInContainer extends Component {
    componentDidMount() {
      // if (!this.props.isLoggedIn) {
      //   this.props.history.push('/');
      // }
      if (localStorage.getItem('ssoToken') === null) {
        this.props.history.push('/');
      }
    }
  
    render() {
      // if (this.props.isLoggedIn) {
      //   return this.props.children;
      // } else {
      //   return null;
      // }
      if (localStorage.getItem('ssoToken') !== null) {
        return this.props.children;
      } else {
        return null;
      }
    }
  }

  const mapStateToProps = state => {
    return {
      isLoggedIn: state.auth.isLoggedIn
    }
  }


  export default withRouter(connect(mapStateToProps)(EnsureLoggedInContainer));
  


// WEBPACK FOOTER //
// ./src/containers/EnsureLoggedInContainer/EnsureLoggedInContainer.js